<div>
    <!--    [routerLink]="'customer-login'"-->
    <button mat-button [matMenuTriggerFor]="menu">
        <span><i class="la la-user"></i>

            <span *ngIf="!customer" i18n>
                Login
            </span>
            <span *ngIf="customer">
                {{customer.firstname}}
                {{customer.lastname}}
            </span>
        </span>
    </button>

    <mat-menu #menu="matMenu">
        <div class="cart-icon-cont p-3" (click)="$event.stopPropagation()">

            <div *ngIf="customer==null">
                <form id="login" [formGroup]="loginForm" (submit)="login()">


                    <div class="form-group">
                        <label i18n>Email</label>
                        <input type="email"
                               id="login_email"
                               name="user_email"
                               class="form-control"
                               formControlName="login_email"
                               autocomplete="off"
                               required=""

                        >
                        <div class="invalid-feedback">
                            <div i18n>Email is required</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label i18n>Password</label>
                        <input type="password"
                               id="login_password"
                               name="login_password"
                               class="form-control"
                               formControlName="login_password"
                               autocomplete="off"
                               required=""

                        >
                        <div class="invalid-feedback">
                            <div i18n>Email is required</div>
                        </div>
                    </div>

                    <div style="    margin-top: 12px;">
                        <div class="pull-left">
                            <a [routerLink]="'/user/password/reset'" (click)="removeSearchBarValue($event)" i18n>Forgot password</a><br>
                        </div>
                        <div class="text-right mt-2 pull-right">


                        </div>
                    </div>
                    <br>
                    <div>
                        <button id="save_new_user_btn" class="btn btn-success btn-block mt-2"
                                type="submit"
                                i18n>
                            <span *ngIf="!isLoggin">Login</span>
                            <span *ngIf="isLoggin"><img src="assets/loader.gif" width="20"/> Please wait ...</span>

                        </button>
                    </div>

                    <div class="mt-3">

                        <a  class="btn  btn-warning btn-block" style="color: #0c0c0c"
                           [routerLink]="'customer/registration'" (click)="removeSearchBarValue($event)" i18n="@@createAccount">Create Account</a>
                    </div>
                </form>

            </div>

            <div *ngIf="customer != null">
                <div class="row">
                    <div class="col-3">
                        <img class="avatar img-fluid" src="assets/customer_avatar.png"/>
                    </div>
                    <div class="col-9">
                        <h6 i18n>
                            You are logged in as
                            <div style="    color: #f39d2f;
    font-weight: 400;">{{customer.firstname}} {{customer.lastname}}</div>
                        </h6>
                    </div>


                </div>
                <div>

                    <button mat-menu-item [routerLink]="'customer/profile'" (click)="removeSearchBarValue($event)" i18n>Profile</button>
                    <button mat-menu-item [routerLink]="'customer/orders'" (click)="removeSearchBarValue($event)" i18n>My Orders</button>
                    <button mat-menu-item [routerLink]="'customer/wishlist'" (click)="removeSearchBarValue($event)" i18n>Wishlist</button>

                </div>


            </div>
            <div class="text-right" *ngIf="customer != null">
                <br>
                <button id="logout-btn" class="btn btn-success btn-block"
                        type="submit" (click)="logout()"
                        i18n>
                    <span *ngIf="!isLogginout">{{'sign_out'|translate}}</span>
                    <span *ngIf="isLogginout"><img src="assets/loader.gif"
                                                   width="20"/>{{'signing_out' | translate}}</span>
                </button>
            </div>
        </div>
    </mat-menu>

</div>
